export default __webpack_public_path__ + "static/media/Anmoll.24c79311.24c79311.jpg";